/** Library card id: `scenarioId` or `scenarioId::missionId` */
export const LIBRARY_ITEM_SEPARATOR = '::';

export function buildLibraryItemId(scenarioId: string, missionId?: string): string {
  return missionId ? `${scenarioId}${LIBRARY_ITEM_SEPARATOR}${missionId}` : scenarioId;
}

export function parseLibraryItemId(id: string): { scenarioId: string; missionId?: string } {
  const separatorIndex = id.indexOf(LIBRARY_ITEM_SEPARATOR);
  if (separatorIndex === -1) {
    return { scenarioId: id };
  }
  return {
    scenarioId: id.slice(0, separatorIndex),
    missionId: id.slice(separatorIndex + LIBRARY_ITEM_SEPARATOR.length),
  };
}
